import React, { createRef } from "react";

import {
    Input,
    Row, Col,
    Card,
    CardBody,
    FormGroup,
    Button,

} from "reactstrap";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import ReactTable from "react-table-legacy";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import _ from 'underscore';
import PropTypes from 'prop-types';

const propTypes = {
    pageChangeFunc: PropTypes.func,
}

export default class CustomTable extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = this.addAllCheckField({
            default_column: this.props.column ? this.props.column : [],
            column: this.props.column ? this.props.column : [],
            data: this.props.data ? this.props.data : [],
            column_select_area_visible: false,
            tmp_column: [],
            detail_search: false,
            with_all_check: this.props.with_all_check ? this.props.with_all_check : false,
            all_check: false,
            mode: this.props.mode ? this.props.mode : 0, // 0: その他大勢 1: 調査詳細モード
            perPage: 50,
            sortOptions:this.props.defaultSortedColumn?this.props.defaultSortedColumn:[],
            display_flex: this.props.display_flex ? this.props.display_flex : false
        });
        // this.addAllCheckField = this.addAllCheckField.bind(this);
        this.handleColumnChange = this.handleColumnChange.bind(this);
        this.setReactTableColumn = this.setReactTableColumn.bind(this);
        this.allCheckChanged = this.allCheckChanged.bind(this);
        this.updateChecked = this.updateChecked.bind(this);
        this.targettedDefaultColumn = this.targettedDefaultColumn.bind(this);
        this.detail_search_field_view = this.detail_search_field_view.bind(this);

        /* 2021/06/08 scroll to list top */
        this.currentRef = createRef();
        this.pageChange = this.pageChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const column = this.state.default_column.map((data) => {
            if(data.defaultView === true){
                return data;
            }else if(data.defaultView === undefined){
                data.show = true;
                return data;
            }else{
                data.show = false;
                return data;
            }
        });
        
        const stringSavedColumn = GsuiteAuth.get(this.props.page_id)
        const jsonSavedColumn = JSON.parse(stringSavedColumn)
        const filteredColumn = jsonSavedColumn && jsonSavedColumn.filter((column)=>column.accessor != 'check')
        this.setState({
            column: column,
            tmp_column:(this.props.page_id&&stringSavedColumn)
                ?(this.state.with_all_check
                    ?[
                        ...filteredColumn
                    ]
                    :jsonSavedColumn)
                :column
        }, ()=>this.setReactTableColumn())
    }
    
    addAllCheckField(state) {
        const checkColumn = { Header: <input type="checkbox" name="all_check" onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true }
        return {
            ...state,
            ...{column: (state.with_all_check && !state.column.find(col=>col.accessor=="check")? [checkColumn,...state.column] : state.column)},
            ...{default_column: (state.with_all_check? [...state.default_column] : state.default_column)}
        }
    }

    allCheckChanged(e) {
        let data = _.map(this.state.data, (item) => {
            item.checked = e.target.checked;
            return item;
        });
        this.setState({ all_check: true, data: data }, () => { this.props.checkedChangeCallback && this.props.checkedChangeCallback(data) });
    }

    componentDidMount(){
        // let ps;
        // let tables = document.querySelectorAll(".rt-table");
        // for (let i = 0; i < tables.length; i++) {
        //     ps = new PerfectScrollbar(tables[i]);
        // }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
            return;

        
        this.setState(this.addAllCheckField({
            ...this.state,
            data:this.props.data
        }));
        
    }


    targettedDefaultColumn() {
        return this.state.default_column.filter((item) => { return !item.nonTargetFilter; });
    }

    //テーブル定義用
    handleColumnChange(e) {
        var column = [];

        _.each(this.state.default_column, (item) => {
            if(item.nonTargetFilter) {
                column.push(item);
            }
        });
        let targetted_default_column = this.targettedDefaultColumn();
        _.each(e.target, (item) => {
            if (!item.nonTargetFilter && item.selected) {
                column.push(targetted_default_column[item.value]);
            }
        });
        this.setState({ tmp_column: column });
        /* 2021/06/08 scroll to list top */
        if ( this.currentRef ) {
            this.currentRef.current.scrollTop = this.currentRef.current.offsetTop;
        }
    }

    getComparableValue(props){
        const tagRegex = /(<([^>]+)>)/ig
        if (props.dangerouslySetInnerHTML){
            return props.dangerouslySetInnerHTML.__html.replace(tagRegex,'')
        } else if (props.children) {
            return props.children.props ? props.children.props.defaultValue: props.children
        } else {
            return props.value
        }
    }

    setReactTableColumn(e) {
        const sortMethod = (a, b) => {
            const valueA = (a && (a.props?this.getComparableValue(a.props):a)) || ""
            const valueB = (b && (b.props?this.getComparableValue(b.props):b)) || ""
            return valueA >= valueB ? 1 : -1;
        }
        const t_column = this.state.tmp_column.map((item) => {
            item.show=true
            const columnData = this.state.default_column.find(element=>element.accessor == item.accessor)
            return {
                ...item,
                ...columnData,
                ...columnData&&(columnData.sortMethod?{}:{sortMethod})
            }
        });
        const checkColumn = { Header: <input type="checkbox" name="all_check" onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true }
        this.setState({ column: (this.state.with_all_check && !t_column.find(col=>col.accessor=="check")? [checkColumn,...t_column] : t_column)});
        GsuiteAuth.set(this.props.page_id, JSON.stringify(this.state.tmp_column))
    }

    updateChecked(e, idx) {
        let data = _.map(this.state.data, (element, index, array) => {
            if (idx === index) {
                element.checked = e.target.checked;
            }
            return element;
        });
        this.setState({ data: data }, this.props.checkedChangeCallback && this.props.checkedChangeCallback(data));
    }

    columnSelectArea() {
        if (this.state.mode === 1)
            return (<></>);
        else
            return (
                <>
                    <Row>
                        {this.detail_search_btn()}
                        <Col md="2">
                            <ButtonWithTooltip
                                onclick={() => { this.setState({ column_select_area_visible: !this.state.column_select_area_visible }); }}
                                class=""
                                id="tmp"
                                icon="fas fa-angle-down"
                                label="表示設定"
                                message="テーブルの表示設定を変更出来ます。"
                            />
                        </Col>
                    </Row>
                    <br />
                    {this.detail_search_field_view()}
                    <Row className={this.state.column_select_area_visible ? 'on' : 'off'}>
                        <Col md="12" className="margin-auto">
                            <Card>
                                <CardBody className={"search-box"}>
                                    <Row>
                                        <Col md="5">
                                            <FormGroup>
                                                <Input type="select" name="column" id="column" onChange={this.handleColumnChange} multiple={true}>
                                                    {this.targettedDefaultColumn().map((data, index) => (
                                                        <option key={index} value={index}>{data.headerLabel ? data.headerLabel : data.Header}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <Button type="button" color="default" onClick={this.setReactTableColumn}>反映</Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </>
            );
    }
    detail_search_btn(){
        // return this.props.detail_search_field
        // console.log('detail_search_field', this.props.detail_search_field)
        if(this.props.detail_search_field){
            return (<>
            <Col md="2">
                <div id="detailed-search-button">
                <ButtonWithTooltip
                    onclick={() => { this.setState({ detail_search: !this.state.detail_search }); }} 
                    class="" 
                    id="detail" 
                    icon="fas fa-angle-down" 
                    label="詳細検索" 
                    message="詳細検索を表示します。" />
                </div>
            </Col>        
            </>);
        }
    }
    detail_search_field_view(){

        if(this.state.detail_search){
            
            return (<>
                <Row className={this.state.detail_search ? 'on' : 'off'}>
                    <Col md="12" className="margin-auto">
                        <Card>
                            <CardBody className={"search-box"}>
                            <Row>
                            {this.props.detail_search_field_cols}
                            </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>   
            </>);     
        }
    }

    pageChange(){
        if ( this.props.pageChangeFunc != undefined ) {
            return this.props.pageChangeFunc( this );
        }
    }

    render() {
        let data = (this.state.with_all_check?this.state.data.map((element, index) => {
            const check = <input type="checkbox" name="item_check" checked={element.checked === true} onChange={(e) => { this.updateChecked(e, index) }} />
            return {
                ...element,
                check
            }
        }):this.state.data)
        
        let columnSelectArea = this.columnSelectArea();
        return (
            <>
                <CardBody>
                    {columnSelectArea}
                    {this.props.checkbox_field_cols}
                    <br/>
                    {this.props.displayLimitMessageFlag === 1 && `＊1000件以上は表示されません。`}
                    <div ref={this.currentRef}></div>
                    <ReactTable
                        page={this.props.page}
                        onPageChange={(p)=>{this.props.handlePageUpdate(p);this.pageChange( this );}}
                        sortable={true}
                        sorted={this.state.sortOptions}
                        onSortedChange={val => {
                            this.setState({ sortOptions: val }) }
                        }
                        data={data}
                        columns={this.state.column}
                        defaultPageSize={this.state.perPage}
                        minRows={3}
                        filterable={false}
                        showPaginationTop={this.state.mode !== 1}
                        showPaginationBottom={true}
                        previousText="前へ"
                        nextText="次へ"
                        rowsText="件表示"
                        loadingText='読込中…'
                        noDataText='検索してください'
                        pageText=''
                        ofText='/'
                        className={"-highlight primary-pagination " + this.state.display_flex ? "display-flex" : ""}
                        getTdProps={(state, rowInfo, column, instance) => {
                            return {
                                onClick: (e, handleOriginal) => {
                                    (this.props.clickRowCallback && rowInfo && rowInfo.index !== undefined) && this.props.clickRowCallback(this.state.data[rowInfo.index]);

                                    // IMPORTANT! React-Table uses onClick internally to trigger
                                    // events like expanding SubComponents and pivots.
                                    // By default a custom 'onClick' handler will override this functionality.
                                    // If you want to fire the original onClick handler, call the
                                    // 'handleOriginal' function.
                                    if (handleOriginal) {
                                        handleOriginal()
                                    }
                                }
                            }
                        }}
                        onPageSizeChange ={(perPage)=>{
                            this.setState({perPage})
                        }}
                        renderTotalPagesCount= {(pages) => {
                            return <span>{pages<=0?1:pages} （計{data.length}件）</span>
                        }}
                    />
                </CardBody>
            </>
        );
    }
}
CustomTable.propTypes = propTypes;